import { TableChart as TableChartIcon } from '@mui/icons-material';
import { GoogleSheetTemplate } from '../store/actions/googleSheetsActions';
import AppConstants from '../constants/AppConstants';

interface MenuItem {
  href: string;
  icon: any;
  title: string;
  role: string[];
  showInFooter?: boolean;
  subMenus?: MenuItem[];
}

export const shouldShowTemplateInMenu = (
  template: GoogleSheetTemplate,
  menuLocation?: string
): boolean => {
  if (!template.menusCsv) {
    return false;
  }

  // If no menu location specified, show all templates with menusCsv
  if (!menuLocation) {
    return false;
  }

  // Check if the template's menusCsv contains the specified menu location
  const menus = template.menusCsv.split(',').map((m) => m.trim().toLowerCase());
  return menus.includes(menuLocation.toLowerCase());
};

export const buildGoogleSheetsMenuItems = (
  templates: GoogleSheetTemplate[],
  menuItems: MenuItem[]
): MenuItem[] => {
  const menus: MenuItem[] = menuItems.map((mi) => ({
    ...mi,
    subMenus: Array.isArray(mi.subMenus) ? [...mi.subMenus] : undefined
  }));

  if (templates && templates.length > 0) {
    templates.forEach((template) => {
      menus.forEach((menuItem) => {
        if (!shouldShowTemplateInMenu(template, menuItem.title)) {
          return;
        }

        // Ensure subMenus is an array (initialize if undefined/null)
        if (!Array.isArray(menuItem.subMenus)) {
          menuItem.subMenus = [];
        }

        const submenuHref = `/app/googlesheet/${template.id}`;

        // Avoid adding duplicates (compare by href)
        const exists = menuItem.subMenus.some((sm) => sm.href === submenuHref);
        if (!exists) {
          // Push the submenu for the template
          menuItem.subMenus.push({
            href: submenuHref,
            icon: TableChartIcon,
            title: template.tabName || `Template ${template.id}`,
            role: [
              AppConstants.USER_ROLES.OWNER,
              AppConstants.USER_ROLES.MANAGER
            ],
            showInFooter: false
          });

          console.log(`Added Google Sheet template to menu: ${template.tabName}`, menuItem);
        } else {
          // Optionally log that we skipped a duplicate
          console.debug(`Skipped duplicate Google Sheet menu for href: ${submenuHref}`, menuItem.title);
        }
      });
    });
  }

  return menus;
};
